export default __webpack_public_path__ + "static/b2-4ba5506303f788b52165e754949a8200.jpg";